import { z } from 'zod';

export const IsoInstant = z
  .string()
  .regex(/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d{3})?Z$/, 'must be ISO-8601 UTC instant');

export const BrandedId = z.string().min(1);

export const ScenarioTypeSchema = z.enum(['TIME_SLOT_BOOKING', 'DINE_IN_SESSION', 'PICKUP_ORDER']);

export const StrategySchema = z.enum(['best_fit', 'center_first', 'lower_index_first']);

export const PartySizeSchema = z.number().int().positive();

export const ExtensionMinutesSchema = z.number().int().positive();

export const ErrorResponse = z.object({
  code: z.string(),
  message: z.string(),
  details: z.unknown().optional(),
});
export type ErrorResponse = z.infer<typeof ErrorResponse>;
